import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input, Container } from "reactstrap";
import SelectBoxSearchNew from "../../common/SelectBoxSearchNew";
import SelectBoxSearchAssetItem from "../../common/SelectBoxSearchAssetItem";
import useFormValidation from "../../common/useFormValidation";
import { TimePicker } from "react-time-picker";
import moment from "moment";
import "../../../style/employee.css";
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
const FormApplyLeaveModern = React.memo((props) => {
  const {
    selectedItem,
    selectedAsset,
    userList,
    handleAddAsset,
    handleUpdateAsset,
    assetItemList,
    typeleaveList,
    holidaycal,
    WeekdayId,
    handlecancel,
    CalendarYearList,
    employeedetails,
    empTask,
    curProjectId
  } = props;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  const [itemNo, setItemNo] = useState(0);
  const [itemModel, setItemModel] = useState("");
  const [itemUniqueId, setItemUniqueId] = useState("");
  const [itemModelNo, setItemModelNo] = useState("");
  const [itemUser, setItemUser] = useState(0);
  const [warrantyEndDate, setWarrantyEndDate] = useState("");
  const [warrentyFile, setWarrentyFile] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [vendor, setVendor] = useState("");
 const [itemId,setItemId]=useState(0);
  const [options,setOptions ]=useState([]);
  const [selectedOption,setSelectedOption]=useState("");
  const [isViewtodate,setisViewtodate]=useState(false);
  const [isViewtime,setisViewtime]=useState(false);
  const [isDayCount,setisDayCount]=useState(true);
  const [curRadiobutton,setcurRadiobutton] =useState(0);
  const [datediff,setdatediff]=useState(0);
  const [fromtime,setfromtime]=useState("9.30");
  const [totime,settotime]=useState("");
  const [dutytype,setdutytype]=useState("");
  const [fromdutytype,setfromdutytype]=useState(1);
  const [todutytype,settodutytype]=useState(1);
  const [leavetype,setleavetype]=useState(1);
  const [leavetypekey,setleavetypekey]=useState("");
  const [reason,setreason]=useState("");
  const [contactdetails,setcontactdetails]=useState("");
  const [handover,sethandover]=useState("");
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const [employeelist,setemployeelist]=useState([]);
  const [daysCount,setDaysCount]=useState(0);
  const [leaveBalance, setLeaveBalance] = useState(null);
  const [taskList,setTaskList] = useState([]);
  const [ccTo, setCcTo] = useState([]);
  const [isInfoVisible, setIsInfoVisible] = useState(true);

  // for item inside asset.
  const [
    formValidationStateAssetItem,
    setFormValidationStateAssetItem,
  ] = useState({});
  const callValidationAssetItem = useRef(false);

  const { formValidation, isFormValid } = useFormValidation(
    formValidationStateAssetItem
  ); // for item inside asset.
  const [loaded, setLoaded] = useState(false);
const sessionOptions = [
  { value: "1", label: "Full Day" },
  { value: "2", label: "Half Day" }
];

  const dynamicMinDate = React.useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const currentDate = now.getDate();
    const currentHours = now.getHours();

    if (currentDate > 27 || (currentDate === 27 && currentHours >= 12)) {
      return new Date(currentYear, currentMonth, 26);
    } else {
      return new Date(currentYear, currentMonth - 1, 26);
    }
  }, []);

  const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
      props.disappear &&
      css`
    display: block; /* show */
  `}
`;
  let holidaylist=[];
  if(holidaycal.length > 0) 
    {
    holidaycal.map(function (hol){
      holidaylist.push(new Date(hol.holidayDate));
    })
  }

  let weekIdlist=[];
  WeekdayId.map(function (hol){
    weekIdlist.push(hol.weekdayId);
  })
  useEffect(() => {
    // calls when asset item's add&edit form is submited.
    callValidationAssetItem.current && callBackAfterValidationAssetItem();
  }, [formValidation]);

  useEffect(()=>{
    //console.log("assetItemList",assetItemList)
    let empArr1 = [];
    let array2 = [];
    const fetchApi = async () => {
      const response = await api.empSkill().GetAllEmployeeList();
      response.data.forEach((element) => {
        if (element.isActive) { // Only push if active
          empArr1.push({
            value: element,
            label: element.employeeName,
            empId: element.employeeId
          });
        }
      });

      setemployeelist(empArr1);
        await api
                    .dbLeaveTypes()
                    .GetLeaveTypesByEmpId(parseInt(loginUser.EmployeeId))
                    .then((res) => array2.push(res.data));
                  setTaskList(array2[0]);
    }
    fetchApi();
    if(assetItemList!=null){
      let empArr = [];

      //only show software Type Assets in Asset Options
      assetItemList.filter(n=>n.itemType == 1).forEach((element) => {
        empArr.push({ value: element, label: element.itemName,itemId:element.itemId });
      });
      setOptions(empArr);

    }
    if (employeedetails.length > 0) 
      {
      setcontactdetails(employeedetails[0].mobileNumber);
    }
  },[assetItemList,setemployeelist,setcontactdetails,employeedetails])
  const validateMobileNumber = (number) => {
    const regex = /^[6-9]\d{9}$/; // Indian mobile number validation (10 digits starting with 6, 7, 8, or 9)
    return regex.test(number);
  };
  const handleCance =(e) =>{
    e.preventDefault();
    handlecancel();
  }
  const handleChange = (e) => {
    const value = e;
    setcontactdetails(value);

    if (!validateMobileNumber(value) && value !== "") {
      setError1("Invalid mobile number. Please enter a valid 10-digit number.");
    } else {
      setError1("");
    }
  };
  // useEffect(() => {

  // }, [selectedItem, selectedAsset, userList]);
  let dayArr = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // function
  const handleFormSubmit = (e) => {
    e.preventDefault();


  };
  const countHolidaysInRange = (fromDate, toDate, holidaylist) => {
    const dt1 = new Date(fromDate);
    const dt2 = new Date(toDate);

    return holidaylist.filter((holiday) => {
      const hDate = new Date(holiday);
      return hDate >= dt1 && hDate <= dt2;
    }).length;
  };
  // asset item valdation's and ADD&EDIT call.
  const date_diff_indays = function (fromDate, toDate, holidaylist, empTask) {
  const dt1 = new Date(fromDate);
  const dt2 = new Date(toDate);

  // normalize to midnight to avoid time drift
  dt1.setHours(0, 0, 0, 0);
  dt2.setHours(0, 0, 0, 0);

  const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
  const isHoliday = (d) => holidaylist?.some(
    (h) => new Date(h).toDateString() === d.toDateString()
  );
  const isNonWorkingDay = (d) => isWeekend(d) || isHoliday(d);

  // Helper: check if a leave exists on a specific date (from empTask)
  const hasLeaveOn = (date) =>
    Array.isArray(empTask) && empTask.some((task) => {
      const taskFrom = new Date(task.fromDate); taskFrom.setHours(0, 0, 0, 0);
      const taskTo = new Date(task.toDate); taskTo.setHours(0, 0, 0, 0);
      const check = new Date(date); check.setHours(0, 0, 0, 0);
      return check >= taskFrom && check <= taskTo && task.leaveStatus !== "Rejected";
    });

  let workingDays = 0;
  let enclosedNonWorking = 0;
  let temp = new Date(dt1);
  while (temp <= dt2) {
    if (!isNonWorkingDay(temp)) {
      workingDays++;
    } else {
      enclosedNonWorking++;
    }
    temp.setDate(temp.getDate() + 1);
  }

  // Trace backwards
  let pastWorkingLeaves = 0;
  let precedingNonWorking = 0;
  let d = new Date(dt1);
  d.setDate(d.getDate() - 1);
  while (isNonWorkingDay(d)) {
    precedingNonWorking++;
    d.setDate(d.getDate() - 1);
  }
  // d is now on the first working day before the immediate non-working block
  while (true) {
    if (isNonWorkingDay(d)) {
      // skip over earlier non-working blocks within the chain
    } else if (hasLeaveOn(d)) {
      pastWorkingLeaves++;
    } else {
      break;
    }
    d.setDate(d.getDate() - 1);
  }

  // Trace forwards
  let futureWorkingLeaves = 0;
  let succeedingNonWorking = 0;
  d = new Date(dt2);
  d.setDate(d.getDate() + 1);
  while (isNonWorkingDay(d)) {
    succeedingNonWorking++;
    d.setDate(d.getDate() + 1);
  }
  // d is now on the first working day after the immediate non-working block
  while (true) {
    if (isNonWorkingDay(d)) {
      // skip over later non-working blocks within the chain
    } else if (hasLeaveOn(d)) {
      futureWorkingLeaves++;
    } else {
      break;
    }
    d.setDate(d.getDate() + 1);
  }

  const effectiveWorkingLeaves = workingDays + pastWorkingLeaves + futureWorkingLeaves;
  let totalCharge = workingDays;

  if (effectiveWorkingLeaves > 3) {
    // Sandwich rule applies!
    totalCharge += enclosedNonWorking;

    // Only charge preceding non-working days if they are truly sandwiched
    if (pastWorkingLeaves > 0) {
      totalCharge += precedingNonWorking;
    }

    // Only charge succeeding non-working days if they are truly sandwiched
    if (futureWorkingLeaves > 0) {
      totalCharge += succeedingNonWorking;
    }
  }

  return totalCharge;
};




  function getDatesInRange(startDate, endDate) {
    const date =new Date(startDate);
  const enddate=new Date(endDate)
    const dates = [];

    while (date <= enddate) {
      dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
      date.setDate(date.getDate() + 1);
    }

    return dates;
  }
  function getDayName(dateStr, locale)
   {
    var date = new Date(dateStr).getDay();
    return date;        
   }

  const setTodatechanes=React.useCallback((todate) =>{

    settoDate(todate);

   if(fromDate !='')
    {
      const newdatediff=date_diff_indays(fromDate,todate,holidaylist,empTask);

      var getDaysArray = getDatesInRange(fromDate, todate)
      let count=0;
      let hollist=[];
      getDaysArray.map(function (day){
        // var day = getDayName(day, "en-IN");
        var outlist=holidaylist.some(item => item === day);
        if(outlist==true)
        {
          hollist.push(outlist);
        }
      
      })
     if(newdatediff<=0)
        {
          setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
         setdatediff(0);
        }
     else
     {
      setdatediff(newdatediff);
      
     }

    }
    else
    {
      setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
      setdatediff(0);
    }
 const newDays = calculateFinalDays(
  fromDate,
  todate,
  fromdutytype,
  todutytype
);
setdatediff(newDays);

  },[fromDate,datediff,settodutytype,fromdutytype,todutytype])
 const checkwithinactiveyaer = (datefor) => {

  if (!Array.isArray(CalendarYearList) || CalendarYearList.length === 0) {
    return true;   // allow selection until data loads
  }

  const yearlist = CalendarYearList.filter(x => x.isActive === true);

  if (yearlist.length === 0) return true;

  const monthfrom = new Date(yearlist[0].monthDurationFrom);
  const monthTo   = new Date(yearlist[0].monthDurationTo);
  const dateto    = new Date(datefor);

  return dateto >= monthfrom && dateto <= monthTo;
};

  const setFromdatechanes=React.useCallback((todate) =>{

    const statusdate= checkwithinactiveyaer(todate);
    setFromDate(todate);

   if(todutytype == 2 || fromdutytype == 2)
    {
      setdatediff(datediff - .5);
    }
    if(toDate != '')
    {
      const newdatediff=date_diff_indays(todate,toDate,holidaylist,empTask);

      var getDaysArray = getDatesInRange(todate, toDate)
      let count=0;
      let hollist=[];
      getDaysArray.map(function (day){
        // var day = getDayName(day, "en-IN");
        var outlist=holidaylist.some(item => item === day);
        if(outlist==true)
        {
          hollist.push(outlist);
        }
      
      })
     if(newdatediff<=0)
        {
          setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
         setdatediff(0);
        }
      //  else if(newdatediff >=5 && hollist.length >0)
      //  {
      //   setdatediff(newdatediff);

      //  }
      //  else if(newdatediff<5 && hollist.length ==0)
      //  {
      //   setdatediff(newdatediff);
      //  }
      else
     {
      setdatediff(newdatediff);
     }
    //  else if(newdatediff<5 && hollist.length >0)
    //  {
    //   setdatediff(newdatediff-hollist.length);
    //  }
     
    //  else
    //  {
    //   setdatediff(newdatediff-hollist.length);
    //  }
    }
    else{
      // setError({ ...error, message: "ToDate must be greater than FromDate" , status: 500 });
      setdatediff(0);
    }
    const newDays = calculateFinalDays(
  todate,
  toDate,
  fromdutytype,
  todutytype
);
setdatediff(newDays);

    // if(dutytype == "")
    // {
    //   alert("Select duty type.");
    //   setFromDate("")
    // }
 
  },[fromDate,dutytype,todutytype,fromdutytype,datediff,setfromdutytype])
 const handleonchangeFromduetytype = React.useCallback((type) => {
  setfromdutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist, empTask);
      if (parseInt(type) === 2 || parseInt(todutytype) === 2) {
        newdatediff -= 0.5;
      }
      setdatediff(
    calculateFinalDays(fromDate, toDate, type, todutytype)
  );
    }
  }, [fromDate, toDate, todutytype, holidaylist, empTask]);
  const handleonchangeToduetytype = React.useCallback((type) => {
    settodutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist, empTask);
      if (parseInt(type) === 2 || parseInt(fromdutytype) === 2) {
        newdatediff -= 0.5;
      }
     setdatediff(
    calculateFinalDays(fromDate, toDate, fromdutytype, type)
  );
    }
  }, [fromDate, toDate, fromdutytype, holidaylist, empTask]);
  const toggleradiobutton =(e) =>{
    setcurRadiobutton(e);
    if(e==1) 
      {
      setisViewtodate(false);
      setisViewtime(true);

    }
    else if(e==2)
    {
      setisViewtodate(false);
      setisViewtime(false);
    }
    else
    {
      setisViewtodate(true);
      setisViewtime(false);
    }
    
  }
  const handleonchangeduetytype = (leaveTypeId) => {

  setleavetype(leaveTypeId);

  if (!leaveTypeId) {
    setLeaveBalance(null);
    return;
  }

  const selectedLeave = taskList.find(
    x => parseInt(x.leaveTypeId) === parseInt(leaveTypeId)
  );

  if (selectedLeave) {
    setLeaveBalance({
      available: selectedLeave.leaveBalance ?? selectedLeave.leaveBalance ?? 0,
      total: selectedLeave.totalLeaves ?? 0
    });
  } else {
    setLeaveBalance({ available: 0, total: 0 });
  }

  if (leaveTypeId === "79") {
    setFromDate(new Date());
    settoDate(new Date());
    sethandover("n");
  }
};

  const formValidationOnSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
       const isValidMobile = /^[6-9]\d{9}$/.test(contactdetails);
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        leavetype: {
          required: true,
          isValid: true,
          value: leavetype,
          errorMessage: "",
        },
        fromDate: {
          required: true,
          isValid: true,
          value: fromDate,
          errorMessage: "",
        },
        toDate: {
          required: true,
          isValid: true,
          value: toDate,
          errorMessage: "",
        },
        reason: {
          required: true,
          isValid: true,
          value: reason,
          errorMessage: "",
        },
        handover: {
          required: true,
          isValid: true,
          value: handover,
          errorMessage: "",
        },
          /* ✅ MOBILE NUMBER VALIDATION */
      contactdetails: {
        required: true,
        isValid: isValidMobile,
        value: contactdetails,
        errorMessage: isValidMobile
          ? ""
          : "Please enter a valid 10-digit mobile number",
      },
        daysCount: {
          required: true,
          isValid: true,
          value: daysCount,
          errorMessage: "",
        },
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [leavetype, fromDate,toDate,reason,handover,contactdetails,daysCount]
  );
function formatForApi(date) {
  // Ensure string "YYYY-MM-DDTHH:mm:ss"
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T00:00:00`;
}

  // asset add after validation.
  const callBackAfterValidationAssetItem = React.useCallback(() => {
    if (isFormValid) {

      setLoaded(true);
      // if form valid.
      let formData = {};
      // console.log(typeof warrentyFile);

      // console.log(itemUser?.value?.employeeId ?? 0);
      try{
        const phoneRegex = /^[0-9]{10}$/;
      
       const isFormValid =
  leavetype !== null &&
  leavetype !== undefined &&
  leavetype !== "" &&
  reason.trim() !== "" &&
  handover.trim() !== "" &&
  contactdetails.trim() !== "" &&
  phoneRegex.test(contactdetails);

        if (isFormValid == true) {

           if(leavetype !='79')
  {
     if(datediff > 0)
     {
          formData = {
           leaveTypeId:parseInt(leavetype),
           employeeId:parseInt(loginUser.EmployeeId),
           fromDate:formatForApi(fromDate), // ✅ "2025-05-23" (YYYY-MM-DD)
           toDate:formatForApi(toDate),
           noOfDays:datediff,
           reason:reason,
           workhandOverTo:handover,
           contactDetails:contactdetails,
           projectId:curProjectId??0,
           employeeList: ccTo.map(item => item.empId).join(',')
          };
          const fetchApi2 = async () => {
          const res=await api.dbCalendarYear().AddEditLeaveApply(formData).then(response =>{
     
            if(response.status == 201)
            {
              setError({ ...error, message: response.data , status: 500 });
              setTimeout(() => { 
                setLoaded(false);
              
            }, 3000);
            }
            else{
              setError({ ...error, message: "Leave Applied." , status: 200 });
               setLoaded(false);
             
              setTimeout(() => { 
                window.location.reload();
                
            }, 3000);
            }

                  //   if(response.data == 'You already applied Leave on this selected Date Range.')
                  //  {
                  //  setError({ ...error, message: "Leave applied successfully..", status: 200 });



                  //  }

                });

              }
              fetchApi2();
            }
            else 
              {
              setError({ ...error, message: "Days must be greater than 0" , status: 500 });
              setTimeout(() => {
                setLoaded(false);

              }, 3000);
            }
          }
         else{
         formData = {
           leaveTypeId:parseInt(leavetype),
           employeeId:parseInt(loginUser.EmployeeId),
          fromDate:formatForApi(fromDate), // ✅ "2025-05-23" (YYYY-MM-DD)
           toDate:formatForApi(toDate),
           noOfDays:daysCount,
           reason:reason,
           workhandOverTo:'',
           contactDetails:contactdetails,
           daysCount:daysCount,
           projectId:curProjectId??0,
           ccTo: ccTo.map(item => item.label).join(',')
          };
          const fetchApi2 = async () => {
          const res=await api.dbCalendarYear().AddEditLeaveApply(formData).then(response =>{
     
            if(response.status == 201)
            {
              setError({ ...error, message: response.data , status: 500 });
              setTimeout(() => { 
                setLoaded(false);
              
            }, 3000);
            }
            else{
              setError({ ...error, message: "Leave Applied." , status: 200 });
              setTimeout(() => { 
                setLoaded(false);
                window.location.reload();
                
            }, 3000);
                }

                //   if(response.data == 'You already applied Leave on this selected Date Range.')
                //  {
                //  setError({ ...error, message: "Leave applied successfully..", status: 200 });



                //  }

              });

            }
            fetchApi2();
          }
        }
        else
    {
      setTimeout(() => { 
        setLoaded(false);
      
    }, 3000);
    }
         //  console.log(res);
         }
         catch(ex)
         {
  
         }
      }
     
  }, [isFormValid, handleFormSubmit,leavetype,fromDate,toDate,datediff,reason,handover,contactdetails]);
const calculateFinalDays = (from, to, fromSession, toSession) => {
  if (!from || !to) return 0;

  let days = date_diff_indays(from, to, holidaylist, empTask);

  // same day logic
  const sameDay =
    new Date(from).toDateString() === new Date(to).toDateString();

  if (sameDay) {
    if (
      parseInt(fromSession) === 2 || // Half
      parseInt(toSession) === 2
    ) {
      return 0.5;
    }
    return days;
  }

  // multi-day adjustment
  if (parseInt(fromSession) === 2) days -= 0.5;
  if (parseInt(toSession) === 2) days -= 0.5;

  return days;
};

  return (
    <Container fluid className="p-4">
      {/* Tabs */}
      {/* <div className="d-flex gap-4 border-bottom mb-3">
        <span className="fw-bold border-bottom border-2 pb-2 importants" >
          Apply
        </span>
     
      </div> */}

      {/* Info Banner */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold">Applying for Leave</h5>
    <Button
  size="sm"
  color="link"
  className="info-toggle-btn"
  onClick={() => setIsInfoVisible(v => !v)}
>
  <span className={`toggle-pill ${isInfoVisible ? "on" : "off"}`} />
</Button>

      </div>
    <div className={`info-wrapper ${isInfoVisible ? "show" : "hide"}`}>
  <div className="alert alert-primary info-banner">
    Leave is earned by an employee and granted by the employer to take time off work.
    The employee is free to avail this leave in accordance with the company policy.
  </div>
</div>


      {/* Card */}

          <Form onSubmit={formValidationOnSubmit}>
            {/* Leave Type */}
            <FormGroup className="mb-3">
              <Label>
                Leave type <span className="text-danger">*</span>
              </Label>
           <Select
 options={typeleaveList
    .slice() // avoid mutating original array
    .sort((a, b) => a.type.localeCompare(b.type))
    .map(el => ({
      value: el.leaveTypeId,
      label: el.type
    }))
  }
  placeholder="Select Leave Type"
  onChange={(opt) => handleonchangeduetytype(String(opt.value))}
  classNamePrefix="leave-select"
/>

                          {Object.keys(formValidation).length !== 0 &&
                            !formValidation.leavetype.isValid && (
                              <span className=" " style={{ color: "red" }}>
                                {formValidation.leavetype.errorMessage}
                              </span>
                            )}
            </FormGroup>

     {leavetype != '79' ? (<Row className="align-items-start">
  {/* LEFT SIDE – Dates & Sessions */}
  <Col md={8}>
    {/* From */}
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>From date *</Label>
          <DatePicker
            className="form-control"
            selected={fromDate}
            dateFormat="dd-MM-yyyy"
            minDate={dynamicMinDate}
            maxDate={new Date("2026-09-30")}
            excludeDates={holidaylist}
            onChange={(e) => {
              if (e) {
                e.setHours(0, 0, 0, 0);
                setFromdatechanes(e);
              }
            }}
          />
        </FormGroup>
      </Col>

      <Col md={6}>
        <FormGroup>
          <Label>Session</Label>
          <Select
            classNamePrefix="leave-select"
            options={sessionOptions}
            value={sessionOptions.find(
              x => x.value === String(fromdutytype)
            )}
            onChange={(opt) => handleonchangeFromduetytype(opt.value)}
          />
        </FormGroup>
      </Col>
    </Row>

    {/* To */}
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>To date *</Label>
          <DatePicker
            className="form-control"
            selected={toDate}
            dateFormat="dd-MM-yyyy"
            minDate={dynamicMinDate}
            maxDate={new Date("2026-09-30")}
            excludeDates={holidaylist}
            onChange={(e) => {
              if (e) {
                e.setHours(0, 0, 0, 0);
                setTodatechanes(e);
              }
            }}
          />
        </FormGroup>
      </Col>

      <Col md={6}>
        <FormGroup>
          <Label>Session</Label>
          <Select
            classNamePrefix="leave-select"
            options={sessionOptions}
            value={sessionOptions.find(
              x => x.value === String(todutytype)
            )}
            onChange={(opt) => handleonchangeToduetytype(opt.value)}
          />
        </FormGroup>
      </Col>
    </Row>
  </Col>

  {/* RIGHT SIDE – Compact Summary */}
  <Col md={4}>
    <div className="border rounded bg-light p-3 h-100 d-flex flex-column justify-content-center" style={{marginTop:"12px"}}>
      <div className="mb-2">
        <small className="text-muted">Leave Balance</small>
        <div className="fw-bold fs-5">
          {leaveBalance?.available ?? 0} days
        </div>
      </div>

      <div>
        <small className="text-muted">Applying For</small>
        <div className="fw-bold fs-5 text-primary">
          {curRadiobutton == 1
            ? 0.5
            : curRadiobutton == 2
            ? 1
            : datediff || 0}{" "}
          days
        </div>
      </div>
    </div>
  </Col>
</Row>):(<Row form>
              <Col md={6}>

                <FormGroup>
                  <Label for="examplePassword">Days</Label>
                  <Input
                    type="number"
                    value={daysCount}
                    name="daysCount"
                    onChange={(e) => setDaysCount(e.target.value)}
                  />
                  {Object.keys(formValidation).length !== 0 &&
                    !formValidation.daysCount.isValid && (
                      <span className=" " style={{ color: "red" }}>
                        {formValidation.daysCount.errorMessage}
                      </span>
                    )}
                </FormGroup>

              </Col>

            </Row>)}


            {/* Reason */}
            <FormGroup>
  <Label>Reason *</Label>
  <Input
    type="textarea"
    rows={3}
    value={reason}
    onChange={(e) => setreason(e.target.value)}
    placeholder="Enter reason for leave"
  />
  {Object.keys(formValidation).length !== 0 &&
    !formValidation.reason.isValid && (
      <span style={{ color: "red" }}>
        {formValidation.reason.errorMessage}
      </span>
    )}
</FormGroup>


            {/* Handover */}
           {leavetype != '79' ? (  <FormGroup>
              <Label>HandOver To</Label>
              <SelectBoxSearchNew
                options={employeelist}
                onChange={(e) => sethandover(e.label)}
                
              />
               {Object.keys(formValidation).length !== 0 &&
                !formValidation.handover.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.handover.errorMessage}
                  </span>
                )}
            </FormGroup>):null}

            {/* Contact */}
            <FormGroup>
              <Label>Contact Details *</Label>
              <Input
                value={contactdetails}
                name="contactdetails"
                onChange={(e) => setcontactdetails(e.target.value)}
              />
              {error1 && <small style={{ color: "red" }}>{error1}</small>}
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.contactdetails.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.contactdetails.errorMessage}
                  </span>
                )}
            </FormGroup>

            {/* CC */}
            <FormGroup>
              <Label>CC to</Label>
              <Select
               classNamePrefix="leave-select"
                isMulti
                options={employeelist}
                value={ccTo}
                onChange={setCcTo}
                placeholder="Select CC recipients"
              />
            </FormGroup>

            {/* Buttons */}
            <div className="text-center mt-4">
             <Button
                           type="submit"
                           color=""
                          className="apply-btn" style={{ width: '120px', background: "#0f9d8a", border: "1.5px solid rgba(255,255,255,0.6)" }}
                           onClick={formValidationOnSubmit}
                           disabled={loaded}
                         >
                           {loaded ? "Applying..." : (selectedAsset !== "" ? "Apply" : "Add")}
                         </Button>
                                    &nbsp;
              <Button
                outline
                className="ms-3 px-4"
                onClick={handlecancel}
                disabled={loaded}
              >
                Cancel
              </Button>
            </div>
          </Form>
       

      <Notifications notifications={error} />

      <DarkBackground show={loaded}>
        <LoadingOverlay active spinner text="Processing..." />
      </DarkBackground>
    </Container>
  );
});

export default FormApplyLeaveModern;
